import '../tooltip';
import '../icon';
import { defineCustomElement, getAttribute, getIntegerAttribute, getReactEventHandler, NectaryElement, updateAttribute, updateIntegerAttribute } from '../utils';
const templateHTML = '<style>:host{display:contents}#icon{--sinch-global-size-icon:18px}</style><sinch-tooltip type="fast"><sinch-icon id="icon" name="help"></sinch-icon></sinch-tooltip>';
const template = document.createElement('template');
template.innerHTML = templateHTML;
defineCustomElement('sinch-help-tooltip', class extends NectaryElement {
  #$tooltip;
  #controller = null;
  constructor() {
    super();
    const shadowRoot = this.attachShadow();
    shadowRoot.appendChild(template.content.cloneNode(true));
    this.#$tooltip = shadowRoot.querySelector('sinch-tooltip');
  }
  connectedCallback() {
    super.connectedCallback();
    this.#controller = new AbortController();
    const options = {
      signal: this.#controller.signal
    };
    this.#$tooltip.addEventListener('-show', this.#onTooltipShow, options);
    this.#$tooltip.addEventListener('-hide', this.#onTooltipHide, options);
    this.addEventListener('-show', this.#onTooltipShowReactHandler, options);
    this.addEventListener('-hide', this.#onTooltipHideReactHandler, options);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller.abort();
    this.#controller = null;
  }
  static get observedAttributes() {
    return ['text', 'width', 'orientation'];
  }
  attributeChangedCallback(name, _, newVal) {
    updateAttribute(this.#$tooltip, name, newVal);
  }
  get text() {
    return getAttribute(this, 'text', '');
  }
  set text(value) {
    updateAttribute(this, 'text', value);
  }
  get width() {
    return getIntegerAttribute(this, 'width');
  }
  set width(value) {
    updateIntegerAttribute(this, 'width', value);
  }
  get orientation() {
    return getAttribute(this, 'orientation', 'top');
  }
  set orientation(value) {
    updateAttribute(this, 'orientation', value);
  }
  get footprintRect() {
    return this.#$tooltip.footprintRect;
  }
  get tooltipRect() {
    return this.#$tooltip.tooltipRect;
  }
  #onTooltipShow = () => {
    this.dispatchEvent(new CustomEvent('-show'));
  };
  #onTooltipHide = () => {
    this.dispatchEvent(new CustomEvent('-hide'));
  };
  #onTooltipShowReactHandler = () => {
    getReactEventHandler(this, 'on-show')?.();
  };
  #onTooltipHideReactHandler = () => {
    getReactEventHandler(this, 'on-hide')?.();
  };
});